export function getTranslationRulesRoutes() {
  return [
    {
      path: "/translation-rules",
      name: "translation-rules",
      component: () => import("./views/TranslationRules.vue"),
    },
  ]
}
